<template>
  <v-container fluid class="pa-0" id="devicesTable">
    <v-row>
      <v-col>
        <v-card>
          <v-data-table
            :headers="tableHeaders"
            :items="filteredDevices"
            :loading="loading"
            :search="search"
            :fixed-header=true
            :height="height"
            class="devicesTable"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100, -1],
              'page-text': '{0} to {1} of {2}'
            }"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-container fluid class="pt-0 pb-0">
                <v-row style="align-items: center;">
                  <v-col lg="3" md="4" sm="4" class="pt-2 pb-0">
                    <v-text-field
                      v-model="search"
                      prepend-inner-icon="search"
                      placeholder="Search devices"
                      clearable
                    />
                  </v-col>
                  <v-divider
                    vertical
                  ></v-divider>
                  <v-col lg="3" md="3" sm="3" class="pt-2 pb-0">
                    <v-select
                      v-model="selectedDateRangeColumn"
                      :items="dateRangeColumns"
                      item-text="name"
                      item-value="value"
                      placeholder="Filter by date column"
                      :clearable=true
                      autowidth
                    ></v-select>
                  </v-col>
                  <v-col lg="4" md="3" sm="3" class="pt-2 pb-0" v-if="selectedDateRangeColumn">
                    <v-menu
                      v-model="datePickerMenu"
                      :close-on-content-click="false"
                      :nudge-right="20"
                      transition="scale-transition"
                      offset-y
                      max-width="290"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          single-line
                          :value="dateFormatted"
                          label="Date range"
                          persistent-hint
                          prepend-inner-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateSelected"
                        @change="datePickerMenu = false"
                        range
                        no-title
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-divider
                    vertical
                  ></v-divider>
                  <v-col class="pt-0 pb-0 pr-6 text-right">
                    <v-menu>
                      <template v-slot:activator="{ on: menu }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              text icon
                              color="#041E42"
                              v-on="{ ...tooltip, ...menu }"
                              @click="arrangeColumns"
                            >
                              <v-icon class="material-icons-outlined">settings</v-icon>
                            </v-btn>
                          </template>
                          <span>Show/hide columns</span>
                        </v-tooltip>
                      </template>
                    </v-menu>

                    <v-menu>
                      <template v-slot:activator="{ on: menu }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                              text icon
                              color="#041E42"
                              v-on="{ ...tooltip, ...menu }"
                              @click="downloadCsv(sitecode)"
                            >
                              <v-icon>save_alt</v-icon>
                            </v-btn>
                          </template>
                          <span>Download current data as CSV</span>
                        </v-tooltip>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-container>
              <v-divider/>
            </template>

            <template v-slot:item="{item, tableHeaders}">
              <tr>
                <td v-if="checkRecordColumn('device_name')">
                  {{item.device_name}}
                </td>
                <td v-if="checkRecordColumn('location')">
                  {{item.location}}
                </td>
                <td v-if="checkRecordColumn('model')">
                  {{item.model}}
                </td>
                <td v-if="checkRecordColumn('serialnumber')">
                  {{item.serialnumber}}
                </td>
                <td v-if="checkRecordColumn('os_service_pack')">
                  {{item.os_service_pack}}
                </td>
                <td v-if="checkRecordColumn('operating_system')">
                  {{item.operating_system}}
                </td>
                <td v-if="checkRecordColumn('release_year')">
                  {{item.release_year}}
                </td>
                <td v-if="checkRecordColumn('warranty')">
                  {{item.warranty}}
                </td>
                <td v-if="checkRecordColumn('cnlastonlinetime')">
                  {{item.cnlastonlinetime}}
                </td>
                <td v-if="checkRecordColumn('cnlastofflinetime')">
                  {{item.cnlastofflinetime}}
                </td>
                <td v-if="checkRecordColumn('device_specification')">
                  {{item.device_specification}}
                </td>
                <td v-if="checkRecordColumn('hdd_size_gb')">
                  {{item.hdd_size_gb }}
                </td>
                <td v-if="checkRecordColumn('total_memory_mb')">
                  {{item.total_memory_mb}}
                </td>
                <td v-if="checkRecordColumn('manufacturer')">
                  {{item.manufacturer}}
                </td>
                <td v-if="checkRecordColumn('form_factor')">
                  {{item.form_factor}}
                </td>
                <td v-if="checkRecordColumn('sitecode')">
                  {{item.sitecode}}
                </td>
                <td v-if="checkRecordColumn('last_logon_user')">
                  {{item.last_logon_user}}
                </td>                
              </tr>
            </template>

            <template v-slot:no-data>
              <v-container fluid>
                <v-row>
                  <v-col cols="6" style="align-self: center;">
                    <span class="subtitle-1 black-color">No matching records found</span><br>
                  </v-col>
                </v-row>
              </v-container>
            </template>

            <template v-slot:no-results>
              <v-container fluid>
                <v-row>
                  <v-col cols="6" style="align-self: center;">
                    <span class="subtitle-1 black-color">No matching records found</span><br>
                  </v-col>
                </v-row>
              </v-container>
            </template>

          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!--    <p>{{ columnsSelected }}</p>-->
    <v-row>
      <v-dialog v-model="dialog" persistent max-width="628px">
        <v-card>
          <v-card-title class="pb-0">
            <span class="subtitle-1 font-weight-bold">Show columns</span>
            <v-spacer/>
            <v-btn icon @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-checkbox v-model="selectAllModel" label="Show all" value="selectAll" class="mb-8" hide-details/>
              </v-row>
              <v-row align="center" justify="space-between">
                <template v-for="(column, index) in columns.slice(0,3)">
                  <v-col :key="column.id" cols="12" sm="4" class="pa-0 pl-4">
                    <v-checkbox
                      :key="index"
                      v-model="columnsSelected"
                      :label="column.name"
                      :value="column.value"
                      :disabled="column.value === 'device_name'"
                    />
                  </v-col>
                </template>
              </v-row>

              <v-row>
                <template v-for="(column, index) in columns.slice(3,6)">
                  <v-col :key="column.id" cols="12" sm="4" class="pa-0 pl-4">
                    <v-checkbox
                      :key="index"
                      v-model="columnsSelected"
                      :label="column.name"
                      :value="column.value"
                      :disabled="column.value === 'device_name'"
                    />
                  </v-col>
                </template>
              </v-row>

              <v-row>
                <template v-for="(column, index) in columns.slice(6,9)">
                  <v-col :key="column.id" cols="12" sm="4" class="pa-0 pl-4">
                    <v-checkbox
                      :key="index"
                      v-model="columnsSelected"
                      :label="column.name"
                      :value="column.value"
                      :disabled="column.value === 'device_name'"
                    />
                  </v-col>
                </template>
              </v-row>

              <v-row>
                <template v-for="(column, index) in columns.slice(9,12)">
                  <v-col :key="column.id" cols="12" sm="4" class="pa-0 pl-4">
                    <v-checkbox
                      :key="index"
                      v-model="columnsSelected"
                      :label="column.name"
                      :value="column.value"
                      :disabled="column.value === 'device_name'"
                    />
                  </v-col>
                </template>
              </v-row>

              <v-row>
                <template v-for="(column, index) in columns.slice(12,columns.length)">
                  <v-col :key="column.id" cols="12" sm="4" class="pa-0 pl-4">
                    <v-checkbox
                      :key="index"
                      v-model="columnsSelected"
                      :label="column.name"
                      :value="column.value"
                      :disabled="column.value === 'device_name'"
                    />
                  </v-col>
                </template>
              </v-row>

              <v-row>
                <v-col cols="12" sm="4" class="pa-0 pl-4">
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions style="justify-content: center;" class="pt-0 pb-6">
            <v-btn x-large color="#041E42" dark @click="saveChanges" style="text-transform: none; width: 285px;">Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
  import {mapActions, mapGetters, mapState} from 'vuex';
  import * as byteSize from '../bytesize';
  import * as lodash from 'lodash';
  import {Parser} from 'json2csv';
  import {format, parse, parseISO, subDays, compareAsc, isValid} from 'date-fns';

  const tableColumns = [
    {name: 'Device Name', value: 'device_name'},
    {name: 'B/L/R Location', value: 'location'},
    {name: 'Model', value: 'model'},
    {name: 'Serial Number', value: 'serialnumber'},
    {name: 'Build Number', value: 'os_service_pack'},
    {name: 'Operating System', value: 'operating_system'},
    {name: 'Model Release Date', value: 'release_year'},
    {name: 'Warranty Expires', value: 'warranty'},
    {name: 'Last Online', value: 'cnlastonlinetime'},
    {name: 'Last Offline', value: 'cnlastofflinetime'},
    {name: 'CPU Spec', value: 'device_specification'},
    {name: 'Local Disk', value: 'hdd_size_gb'},
    {name: 'Memory', value: 'total_memory_mb'},
    {name: 'Manufacturer', value: 'manufacturer'},
    {name: 'Form Factor', value: 'form_factor'},
    {name: 'School Code', value: 'sitecode'},
    {name: 'Last Logon User', value: 'last_logon_user'}
  ];

  const allHeaders = [
    {
      text: tableColumns[0].name,
      align: 'left',
      value: tableColumns[0].value,
      selected: false,
    },
    {
      text: tableColumns[1].name,
      align: 'left',
      value: tableColumns[1].value,
      selected: false,
    },
    {
      text: tableColumns[2].name,
      align: 'left',
      value: tableColumns[2].value,
      selected: false,
    },
    {
      text: tableColumns[3].name,
      align: 'left',
      value: tableColumns[3].value,
      selected: false,
    },
    {
      text: tableColumns[4].name,
      align: 'left',
      value: tableColumns[4].value,
      selected: false,
    },
    {
      text: tableColumns[5].name,
      align: 'left',
      value: tableColumns[5].value,
      selected: false,
    },
    {
      text: tableColumns[6].name,
      align: 'left',
      value: tableColumns[6].value,
      selected: false,
    },
    {
      text: tableColumns[7].name,
      align: 'left',
      value: tableColumns[7].value,
      selected: false,
    },
    {
      text: tableColumns[8].name,
      align: 'left',
      value: tableColumns[8].value,
      selected: false,
    },
    {
      text: tableColumns[9].name,
      align: 'left',
      value: tableColumns[9].value,
      selected: false,
    },
    {
      text: tableColumns[10].name,
      align: 'left',
      value: tableColumns[10].value,
      selected: false,
    },
    {
      text: tableColumns[11].name,
      align: 'left',
      value: tableColumns[11].value,
      selected: false,
    },
    {
      text: tableColumns[12].name,
      align: 'left',
      value: tableColumns[12].value,
      selected: false,
    },
    {
      text: tableColumns[13].name,
      align: 'left',
      value: tableColumns[13].value,
      selected: false,
    },
    {
      text: tableColumns[14].name,
      align: 'left',
      value: tableColumns[14].value,
      selected: false,
    },
    {
        text: tableColumns[15].name,
        align: 'left',
        value: tableColumns[15].value,
        selected: false,
    },
    {
        text: tableColumns[16].name,
        align: 'left',
        value: tableColumns[16].value,
        selected: false,
    }
  ];

  //const defaultDateRange = [subDays(new Date(), 30).toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
  const defaultDateRange = [];

  export default {
    name: 'DevicesTable',
    props: ['sitecode', 'loading', 'error', 'dashboard'],
    data() {
      return {
        // search model to set the search bar
        search: '',
        tableHeaders: [],
        dialog: false,
        columnsSelected: [],
        columns: [...tableColumns.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))],
        //columns: [...tableColumns],
        DATA_NOT_AVAILABLE: 'Data not available',
        height: 600,
        dateRangeColumns: [
          {name: 'Model Release Date', value: 'release_year'},
          {name: 'Warranty Expires', value: 'warranty'},
          {name: 'Last Online', value: 'cnlastonlinetime'},
          {name: 'Last Offline', value: 'cnlastofflinetime'},
        ],
        selectedDateRangeColumn: null,
        datePickerMenu: false,
        dateSelected: [],
        minDateRange: subDays(new Date(), 60).toISOString().substr(0, 10),
        maxDateRange: new Date().toISOString().substr(0, 10),
      };
    },
    methods: {
      ...mapActions(['fetchDevices', 'setDevicePagination']),
      byteSize: byteSize,
      sendEventToGA(actionName, sitecode) {
        this.$ga.event({
          eventCategory: 'Planning Dashboard',
          eventAction: `${actionName}`,
          eventLabel: `sitecode:${sitecode}`
        });
      },
      filterDeviceBasedOnSelectedColumn() {
        let filteredDevice = [];
        const curResult = this.filteredDevices;
        if (Array.isArray(curResult) && curResult.length > 0) {
          if (Array.isArray(this.columnsSelected) && this.columnsSelected.length > 0) {
            filteredDevice = curResult.map((device) => {
              return Object.keys(device)
                .filter(key => this.columnsSelected.includes(key))
                .reduce((obj, key) => {
                  obj[key] = device[key];
                  return obj;
                }, {});
            })
          } else {
            filteredDevice = this.devices;
          }
        }
        return filteredDevice;
      },
      changeDeviceKeyToColumnName() {
        let filteredDeviceWithHeader = [];
        const filteredDevice = this.filterDeviceBasedOnSelectedColumn();
        if (Array.isArray(filteredDevice) && filteredDevice.length > 0) {
          filteredDeviceWithHeader = filteredDevice.map((device) => {
            return Object.keys(device).reduce((obj, key) => {
              const column = tableColumns.filter(column => column.value === key);
              if (Array.isArray(column) && column.length > 0) {
                obj[column[0].name] = device[key];
              }
              return obj;
            }, {});
          });
        }
        return filteredDeviceWithHeader;
      },
      downloadCsv(sitecode) {
        this.sendEventToGA('csv download click', sitecode);
        const deviceWithColumnNames = this.changeDeviceKeyToColumnName();

        if (Array.isArray(deviceWithColumnNames) && deviceWithColumnNames.length > 0) {
          const columnHeaderNames = Object.keys(deviceWithColumnNames[0]);
          const json2csvParser = new Parser({columnHeaderNames});
          const csv = json2csvParser.parse(deviceWithColumnNames);

          const url = window.URL.createObjectURL(new Blob([csv]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'devices.csv');
          document.body.appendChild(link);
          link.click();
        }
      },
      arrangeColumns() {
        this.dialog = true;
      },
      close() {
        this.dialog = false;
      },
      saveChanges() {
        console.log('this.columnsSelected', this.columnsSelected);
        this.saveColumnSelectedToStorage();

        this.tableHeaders = this.filterHeaderBySelectedColumn(this.columnsSelected);
        console.log(this.tableHeaders);

        this.dialog = false;
      },
      filterHeaderBySelectedColumn(selectedColumns) {
        let newHeaders = [];
        const currentHeaders = lodash.cloneDeep(allHeaders);
        if (selectedColumns && selectedColumns.length > 0) {
          currentHeaders.forEach((header) => {
            if (selectedColumns.includes(header.value)) {
              header.selected = true;
            }
          });
          newHeaders = currentHeaders.filter(header => header.selected === true);
        }
        return newHeaders;
      },
      checkRecordColumn(column) {
        return this.columnsSelected.includes(column);
      },
      saveColumnSelectedToStorage() {
        this.sendEventToGA('selected columns:' + JSON.stringify(this.columnsSelected), this.sitecode);
        if (localStorage) {
          localStorage.setItem("columnsSelected", JSON.stringify(this.columnsSelected));
        }
      },
      getColumnSelectedFromStorage() {
        let selectedColumns = this.columns.map((column) => {
          return column.value;
        });
        if (localStorage) {
          if (localStorage.getItem("columnsSelected")) {
            selectedColumns = JSON.parse(localStorage.getItem("columnsSelected"));
          }
        }
        return selectedColumns;
      },
      buildRangeSelected(dateSelected) {
        let dateRangeSelected = lodash.cloneDeep(dateSelected);
        dateRangeSelected = dateRangeSelected.map(dateItem => {
          return parse(dateItem, 'yyyy-MM-dd', new Date());
        });
        dateRangeSelected.sort((a, b) => compareAsc(a, b));
        return dateRangeSelected;
      },
      getDateRange(dateSelected) {
        let dateRangeSelected = this.buildRangeSelected(dateSelected);
        let dateRangeFilter = {
          startDate: '',
          endDate: '',
        };
        if (Array.isArray(dateRangeSelected) && dateRangeSelected.length > 0) {
          if (dateRangeSelected.length > 1) {
            const startDate = dateRangeSelected[0].toISOString();
            const endDate = dateRangeSelected[1].toISOString();
            dateRangeFilter.startDate = startDate;
            dateRangeFilter.endDate = endDate;
          } else {
            const startDate = dateRangeSelected[0].toISOString();
            dateRangeFilter.startDate = startDate;
            dateRangeFilter.endDate = startDate;
          }
        }
        return dateRangeFilter;
      },
      clearDateRange() {
        this.dateSelected = defaultDateRange;
      }
    },
    mounted() {
      this.fetchDevices({sitecode: this.sitecode, ...this.pagination});
      this.columnsSelected = this.getColumnSelectedFromStorage();
      this.tableHeaders = this.filterHeaderBySelectedColumn(this.columnsSelected);
    },
    computed: {
      ...mapGetters(['devices', 'authToken']),
      ...mapState({filters: state => state.api.filters}),
      token: function () {
        return sessionStorage.getItem('ictp-token');
      },
      selectAllModel: {
        set: function (val) {
          if (val === 'selectAll') {
            this.columnsSelected = this.columns.map((column) => {
              return column.value;
            });
            this.tableHeaders = allHeaders;
          } else {
            this.columnsSelected = ['device_name'];
            this.tableHeaders = allHeaders.slice(0, 1);
          }
        },
        get: function(){
          if(this.columnsSelected.length === tableColumns.length){
            return "selectAll";
          }
          return "";
        }
      },
      dateFormatted() {
        let dateRangeSelected = this.buildRangeSelected(this.dateSelected);
        dateRangeSelected = dateRangeSelected.map(dateItem => {
          return format(dateItem, 'dd/MMM/yyyy');
        });
        return dateRangeSelected.join(' ~ ');
      },
      filteredDevices() {
        if (this.devices) {
          const dateRange = this.getDateRange(this.dateSelected);
          if (this.selectedDateRangeColumn && dateRange) {
            const startDate = parseISO(dateRange.startDate);
            const endDate = parseISO(dateRange.endDate);
            const filteredItems = this.devices.filter((item) => {
              const columnData = item[this.selectedDateRangeColumn];
              if (columnData && columnData !== 'Data not available') {
                const columnTime = parse(columnData, 'dd/MM/yyyy', new Date());
                if (isValid(columnTime)) {
                  return columnTime.getTime() >= startDate.getTime() && columnTime.getTime() <= endDate.getTime();
                }
              }
              return false;
            });
            return filteredItems;
          } else {
            return this.devices;
          }
        }
        return [];
      }
    },
    watch: {
      filters: {
        handler: function () {
          this.fetchDevices({sitecode: this.sitecode, ...this.pagination});
        },
        deep: true,
      },
      sitecode: function (value) {
        this.fetchDevices({
          sitecode: this.sitecode,
          filters: value,
          ...this.pagination,
        });
      },
      devicePagination: function (value) {
        this.fetchDevices({
          ...value,
          sitecode: this.sitecode,
          filters: value
        });
      },
    }
  };
</script>

<style scoped>

  .devicesTable >>> .select {
    min-width: 290px;
  }

  .devicesTable >>> table thead.v-data-table-header tr {
    line-height: 56px;
  }

  .devicesTable >>> table thead.v-data-table-header tr th {
    white-space: nowrap;
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    top: 0;
  }

  .devicesTable >>> table thead.v-data-table-header tr th:first-child {
    top: 0;
    left: 0;
    z-index: 4;
    border-right: 1px solid #CCC;
    background: #FFF;
  }

  .devicesTable >>> table tr {
    line-height: 52px;
  }

  .devicesTable >>> table tr td {
    white-space: nowrap;
  }

  /*.devicesTable >>> table tr:nth-of-type(even) {*/
  /*  background-color: rgb(236, 237, 237);*/
  /*}*/

  /*.devicesTable >>> table tr:nth-of-type(odd) {*/
  /*  background-color: rgb(250 ,250, 250);*/
  /*}*/

  .devicesTable >>> table tr td:first-child {
    position: -webkit-sticky; /* for Safari */
    position: sticky;
    left: 0;
    border-right: 1px solid #CCC;
    background: #FFF;
  }

  .theme--light.v-data-table .v-data-footer {
    border-top: none;
  }

  #devicesTable >>> .black-color {
    color: #041E42 !important;
  }
</style>

